module.exports = __webpack_public_path__ + "img/login-background.5e08845c.png";